import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'

function SocietyCorner() {
  return (
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec">
        
    <h1>Society's Corner</h1>
    <p>Coming Soon</p>

    </div>

    <div class="col-sm-4 float-left">
      <RightSidebarGlobal/>
    </div>

    </div>
    </div>
  )
}

export default SocietyCorner